"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EditorDrawerTab {
    constructor() {
        this.order = 0;
    }
    isVisible(_payload) {
        return true;
    }
    getBadgeCount(_payload) {
        return 0;
    }
}
exports.default = EditorDrawerTab;
